import * as variables from './variables.js';

import "./Analytics";

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);


// NOTE: Colorbox must see jQuery on the window in order to work properly
import * as $ from 'jquery';
declare global {
	interface Window { jQuery: JQueryStatic; }
}
window.jQuery = $;

import './component/menu.service';

import Forms from './component/Forms';
Forms.init();

// @ts-ignore
require('./lib/FormMask.js').init();

import CookiesNotification from './component/CookiesNotification';
new CookiesNotification();

import * as stickybits from 'stickybits';
const stickybit = (stickybits as any)('.childMenuBar', {
	useStickyClasses: true
});


import 'intersection-observer';
import Promotion from './component/Promotion';
new Promotion();

// import IntersectionObserverLightboxForm from './component/IntersectionObserverLightboxForm';
// new IntersectionObserverLightboxForm();

import LightboxFormBusiness from './component/LightboxFormBusiness/LightboxFormBusiness';
new LightboxFormBusiness();

import LightboxFormResidential from './component/LightboxFormResidential/LightboxFormResidential';
new LightboxFormResidential();

import SmoothScroll from './lib/SmoothScroll';
const mySmoothScroll = new SmoothScroll();
mySmoothScroll.add('.productGroup a[href*="#"]');


import CollapsableGroup from './component/CollapsableGroup';
new CollapsableGroup();

import getQuote from './component/GetQuote';
getQuote();

import lightboxer from './component/lightboxer';
lightboxer();